import React from 'react';
import CreateDistrictMap from '../../components/districts/create-district-map';

const CreateDistricts = props => {
    const search = {};
    return (
        <>
            <CreateDistrictMap search={search} type={props.type} />
        </>
    );
};

export default CreateDistricts;